// 设备监测
export default {
  install(Vue) {
    const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      navigator.userAgent
    );

    Vue.prototype.$device = {
      isMobile,
      isPC: !isMobile
    };
  }
};
